import { createDocumentSagas, createContactSagas } from '@tempus/t-shared/ui';

import api from './api';
import { sagas as documentEditSagas } from './documentEdit';
import { sagas as enchanceUserSagas } from './enhanceUser';
import { sagas as patientTrackerV3Sagas } from './patientTrackerV3';
import { sagas as siteSagas } from './site';
import {
  sagasCarePathways as timeScreeningSagasCarePathways,
  sagasTrials as timeScreeningSagasTrials,
} from './timeScreening';
import { sagas as trialSagas } from './trial';
import { sagas as trialSearchSagas } from './trialSearch';

const documentSagas = createDocumentSagas({
  getSiteDocuments: api.documents.getSite,
  getTrialDocuments: api.documents.getTrialDocuments,
});

const contactSagas = createContactSagas(api.contact);

export default [
  ...contactSagas,
  ...documentSagas,
  ...documentEditSagas,
  ...enchanceUserSagas,
  ...patientTrackerV3Sagas,
  ...siteSagas,
  ...timeScreeningSagasTrials,
  ...timeScreeningSagasCarePathways,
  ...trialSagas,
  ...trialSearchSagas,
];
